<form [formGroup]="form">
  <gl-input-container [units]="'length'">
    <input
      type="text"
      [numericType]="'float'"
      placeholder="length"
      normal-input
      formControlName="loadLength"
      />
  </gl-input-container>

  <gl-select placeholder="loading_space" formControlName="loadingSpace">
    @for (loadingSpace of loadingSpaces; track loadingSpace) {
      <gl-option
        [value]="loadingSpace"
        [label]="loadingSpace.name"
      ></gl-option>
    }
  </gl-select>
  <button normal-button (click)='createProject()'>{{ 'send' | translate}}</button>
</form>

<div>
  <ul class="clear">
    @for (color of colors; track color; let i = $index) {
      <li class="hex">
        <div
          class="hexagon"
          [ngStyle]="{background: color}"
          (click)="changeColor(i)"
        ></div>
      </li>
    }
  </ul>
</div>
